var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("MenuBar"),
      _c("router-view", { staticClass: "container" }),
      _vm.isLoading
        ? _c("div", { attrs: { id: "loading-overlay" } }, [
            _c("div", { staticClass: "spinner" }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }